import { useState } from "react";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OtpBoxes } from "@/components/TwoFactorStep";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { authHeader, errText } from "@/lib/aadhaar";

export const EmailVerifyCard = ({ email, onVerified }) => {
  const { L } = useLang();
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(errText(e.response?.data?.detail)); setCode(""); } finally { setBusy(false); } };
  const send = () => run(async () => { await api.post("/student/email/send-code", {}, authHeader("student")); setSent(true); toast.success(L(`Code sent to ${email}`, `${email} पर कोड भेजा गया`)); });
  const verify = () => run(async () => { await api.post("/student/email/verify", { code }, authHeader("student")); toast.success(L("Email confirmed", "ईमेल की पुष्टि हो गई")); onVerified(); });

  return (
    <div className="rounded-3xl border border-[#FFC94D]/40 bg-[#FFC94D]/5 p-6" data-testid="email-verify-card">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex gap-3">
          <MailCheck className="w-6 h-6 text-[#B45309] shrink-0" />
          <div>
            <div className="font-extrabold text-[#0A192F]">{L("Confirm your email address", "अपना ईमेल पता कन्फ़र्म करें")}</div>
            <p className="text-sm text-slate-600">{L(`Your admission can be approved only after you confirm ${email}.`, `${email} कन्फ़र्म करने के बाद ही दाखिला मंज़ूर हो सकता है।`)}</p>
          </div>
        </div>
        <Button onClick={send} disabled={busy} variant={sent ? "outline" : "default"} className={sent ? "bg-transparent rounded-full" : "rs-cta rounded-full"} data-testid="email-verify-send-btn">
          {busy && !sent ? <Loader2 className="w-4 h-4 animate-spin" /> : sent ? L("Resend code", "कोड दोबारा भेजें") : L("Send code", "कोड भेजें")}
        </Button>
      </div>
      {sent && (
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <OtpBoxes value={code} onChange={setCode} testid="email-verify-code" />
          <Button onClick={verify} disabled={busy || code.length !== 6} className="rs-cta rounded-full" data-testid="email-verify-submit-btn">{L("Confirm", "कन्फ़र्म करें")}</Button>
        </div>
      )}
    </div>
  );
};
